export const cities = [
  {
    slug: "zuerich",
    name: "Zürich",
    canton: { de: "Kanton Zürich", en: "Canton of Zurich" },
    de: {
      intro: [
        "Zürich ist das wirtschaftliche Herz der Schweiz – und einer der anspruchsvollsten Wohnmärkte Europas mit einer Leerstandsquote von unter einem halben Prozent. Ob Sie für eine internationale Bank, ein Tech-Unternehmen oder eine Organisation nach Zürich ziehen: Unsere Relocation Services in Zürich finden die richtige Wohnung im richtigen Kreis, erledigen Anmeldung und Bewilligungen und bringen Sie schnell und stressfrei an.",
        "Als Ihre persönliche Assistenz in Zürich entlasten wir Sie im Arbeitsalltag und privat – von der Terminplanung bis zum Lifestyle Management. Diskret, zuverlässig und mit bestem lokalen Netzwerk, vom Seefeld bis zum Zürichberg.",
      ],
      highlights: [
        "Wohnungssuche in allen Zürcher Kreisen, am Zürichsee & Zürichberg",
        "Anmeldung Stadthaus & Migrationsamt Kanton Zürich",
        "Internationale Schulen & Kitas in Zürich",
        "Netzwerk aus Ärzten, Banken & Dienstleistern",
        "Begleitung auf Deutsch, Englisch & Zürideutsch",
      ],
    },
    en: {
      intro: [
        "Zurich is the economic heart of Switzerland – and one of Europe's most competitive housing markets, with a vacancy rate below half a percent. Whether you are moving to Zurich for an international bank, a tech company or an organisation: our relocation services in Zurich find the right home in the right district, handle registration and permits, and get you settled quickly and stress-free.",
        "As your personal assistant in Zurich, we take the load off your working day and private life – from diary management to lifestyle management. Discreet, reliable and with an outstanding local network, from Seefeld to Zürichberg.",
      ],
      highlights: [
        "Home search across all Zurich districts, Lake Zurich & Zürichberg",
        "Registration at the Stadthaus & cantonal migration office",
        "International schools & childcare in Zurich",
        "Network of doctors, banks & service providers",
        "Support in German, English & Swiss German",
      ],
    },
  },
  {
    slug: "genf",
    name: "Genf",
    canton: { de: "Kanton Genf", en: "Canton of Geneva" },
    de: {
      intro: [
        "Genf ist die internationale Stadt der Schweiz: UNO, CERN, Dutzende NGOs und globale Unternehmen ziehen Fachkräfte aus aller Welt an. Der Wohnungsmarkt gehört mit einer Leerstandsquote von rund 0,3 Prozent zu den angespanntesten des Landes. Unsere Relocation Services in Genf führen Sie sicher durch Wohnungssuche, Anmeldung beim OCP und alle administrativen Schritte – auf Französisch, Englisch und Deutsch.",
        "Ob Diplomat, internationale Fachkraft oder Unternehmerfamilie: Ihre persönliche Assistenz und Ihr Lifestyle Concierge in Genf organisieren Ihren Alltag, damit Sie sich vom ersten Tag an zu Hause fühlen – von Cologny bis Champel.",
      ],
      highlights: [
        "Wohnungssuche in Genf, Cologny, Champel & Carouge",
        "Anmeldung OCP & kantonale Bewilligungen",
        "Services für internationale Organisationen & Diplomaten",
        "Internationale & französischsprachige Schulberatung",
        "Dreisprachige Begleitung: Französisch, Englisch, Deutsch",
      ],
    },
    en: {
      intro: [
        "Geneva is Switzerland's international city: the UN, CERN, dozens of NGOs and global companies attract professionals from all over the world. With a vacancy rate of around 0.3 percent, its housing market is among the tightest in the country. Our relocation services in Geneva guide you safely through the home search, OCP registration and every administrative step – in French, English and German.",
        "Whether diplomat, international professional or entrepreneurial family: your personal assistant and lifestyle concierge in Geneva organise your everyday life so you feel at home from day one – from Cologny to Champel.",
      ],
      highlights: [
        "Home search in Geneva, Cologny, Champel & Carouge",
        "OCP registration & cantonal permits",
        "Services for international organisations & diplomats",
        "International & French-speaking school advice",
        "Trilingual support: French, English, German",
      ],
    },
  },
  {
    slug: "zug",
    name: "Zug",
    canton: { de: "Kanton Zug", en: "Canton of Zug" },
    de: {
      intro: [
        "Zug ist unsere Heimat – und einer der beliebtesten Wirtschaftsstandorte der Schweiz. Das Crypto Valley, tiefe Steuern und die Lage zwischen Zürich und Luzern ziehen Unternehmer und internationale Fachkräfte an. Entsprechend umkämpft ist der Wohnungsmarkt. Von unserem Sitz an der Baarerstrasse 43 betreuen wir Ihre Relocation nach Zug persönlich: Wohnungssuche, Einwohnerkontrolle, Schulen – alles aus einer Hand.",
        "Als Personal Assistant und Lifestyle Concierge in Zug sind wir vor Ort verwurzelt und kennen jede Adresse – vom Zugersee bis zur Altstadt. Diskretion und persönliche Nähe sind bei uns kein Versprechen, sondern gelebter Alltag.",
      ],
      highlights: [
        "Wohnungssuche in Zug, Baar, Cham & Risch",
        "Einwohnerkontrolle & Bewilligungen Kanton Zug",
        "Beratung für Unternehmer & Crypto-Valley-Professionals",
        "Internationale Schulen: ISZL, Montana & mehr",
        "Unser Hauptsitz: Baarerstrasse 43, 6300 Zug",
      ],
    },
    en: {
      intro: [
        "Zug is our home – and one of Switzerland's most popular business locations. The Crypto Valley, low taxes and its position between Zurich and Lucerne attract entrepreneurs and international professionals, making the housing market highly competitive. From our base at Baarerstrasse 43 we manage your relocation to Zug personally: home search, resident registration, schools – all from a single source.",
        "As a personal assistant and lifestyle concierge in Zug we are rooted locally and know every address – from Lake Zug to the old town. For us, discretion and personal closeness are not a promise but everyday practice.",
      ],
      highlights: [
        "Home search in Zug, Baar, Cham & Risch",
        "Resident registration & cantonal permits",
        "Advice for entrepreneurs & Crypto Valley professionals",
        "International schools: ISZL, Montana & more",
        "Our headquarters: Baarerstrasse 43, 6300 Zug",
      ],
    },
  },
  {
    slug: "luzern",
    name: "Luzern",
    canton: { de: "Kanton Luzern", en: "Canton of Lucerne" },
    de: {
      intro: [
        "Luzern verbindet Lebensqualität am Vierwaldstättersee mit einer starken Wirtschaft in Tourismus, Versicherungen und Industrie. Wer in die Leuchtenstadt zieht, profitiert von kurzen Wegen und einem internationalen Umfeld. Unsere Relocation Services in Luzern begleiten Sie von der Wohnungssuche über die Anmeldung bis zur Schulwahl – persönlich und mit lokaler Erfahrung.",
        "Ihre persönliche Assistenz in Luzern hält Ihnen den Rücken frei: Termine, Korrespondenz, Reisen und alle kleinen Dinge des Alltags. Und unser Lifestyle Concierge öffnet Ihnen Türen – vom KKL bis zu den besten Adressen der Region.",
      ],
      highlights: [
        "Wohnungssuche in Luzern, Kriens, Emmen & Meggen",
        "Anmeldung & Bewilligungen Kanton Luzern",
        "Schulberatung & Kinderbetreuung in der Zentralschweiz",
        "Netzwerk entlang des Vierwaldstättersees",
        "Persönliche Betreuung auf Deutsch & Englisch",
      ],
    },
    en: {
      intro: [
        "Lucerne combines quality of life on Lake Lucerne with a strong economy in tourism, insurance and industry. New arrivals benefit from short distances and an international environment. Our relocation services in Lucerne accompany you from the home search and registration to choosing schools – personally and with local experience.",
        "Your personal assistant in Lucerne frees up your time: appointments, correspondence, travel and all the little things of everyday life. And our lifestyle concierge opens doors – from the KKL to the finest addresses in the region.",
      ],
      highlights: [
        "Home search in Lucerne, Kriens, Emmen & Meggen",
        "Registration & permits in the canton of Lucerne",
        "School & childcare advice in Central Switzerland",
        "Network along Lake Lucerne",
        "Personal support in German & English",
      ],
    },
  },
  {
    slug: "schwyz",
    name: "Schwyz",
    canton: { de: "Kanton Schwyz", en: "Canton of Schwyz" },
    de: {
      intro: [
        "Der Kanton Schwyz bietet steuerliche Vorteile, alpine Lebensqualität und hervorragende Erreichbarkeit von Zürich und Zug. Viele Unternehmer und Familien wählen bewusst Schwyz, Brunnen oder Einsiedeln als Wohnort. Unsere Relocation Services im Kanton Schwyz kennen die Gemeinden, Behörden und Abläufe – für einen unkomplizierten Neustart.",
        "Ob persönliche Assistenz für Ihren Arbeitsalltag oder ein Lifestyle Concierge für Freizeit und Familie: In Schwyz betreuen wir Sie mit der Diskretion, die diese Region auszeichnet.",
      ],
      highlights: [
        "Wohnungssuche in Schwyz, Brunnen, Einsiedeln & Küssnacht",
        "Gemeinde-Anmeldung & kantonale Bewilligungen",
        "Attraktive Steuerlage & Standortberatung",
        "Schulen & Familien-Services im Kanton Schwyz",
        "Diskrete Betreuung für Unternehmer & Familien",
      ],
    },
    en: {
      intro: [
        "The canton of Schwyz offers tax advantages, alpine quality of life and excellent access to Zurich and Zug. Many entrepreneurs and families deliberately choose Schwyz, Brunnen or Einsiedeln as their place of residence. Our relocation services in the canton of Schwyz know the municipalities, authorities and processes – for an uncomplicated fresh start.",
        "Whether personal assistance for your working day or a lifestyle concierge for leisure and family: in Schwyz we look after you with the discretion that defines this region.",
      ],
      highlights: [
        "Home search in Schwyz, Brunnen, Einsiedeln & Küssnacht",
        "Municipal registration & cantonal permits",
        "Attractive tax situation & location advice",
        "Schools & family services in the canton of Schwyz",
        "Discreet care for entrepreneurs & families",
      ],
    },
  },
  {
    slug: "hoefe",
    name: "Höfe",
    canton: { de: "Bezirk Höfe · Kanton Schwyz", en: "Höfe District · Canton of Schwyz" },
    de: {
      intro: [
        "Die Region Höfe – mit Wollerau, Freienbach und Pfäffikon SZ – zählt zu den begehrtesten Wohnlagen der Schweiz: tiefe Steuern, Top-Infrastruktur und nur 25 Minuten nach Zürich. Entsprechend exklusiv ist der Immobilienmarkt. Unsere Relocation Services in der Region Höfe verschaffen Ihnen Zugang zu den besten Objekten und begleiten Sie durch alle Amtswege.",
        "Viele unserer Kunden in Höfe sind Unternehmerfamilien und Führungskräfte. Ihre persönliche Assistenz und Ihr Lifestyle Concierge sind hier fest verankert – von der Haushaltsführung bis zur Eventplanung am Zürichsee.",
      ],
      highlights: [
        "Wohnungssuche in Wollerau, Freienbach & Pfäffikon SZ",
        "Exklusive Immobilien & Off-Market-Objekte",
        "Gemeinde-Anmeldung & Behördenwege Bezirk Höfe",
        "Familien-Services: Schulen, Kitas & Vereine",
        "25 Minuten nach Zürich – perfekt vernetzt",
      ],
    },
    en: {
      intro: [
        "The Höfe region – with Wollerau, Freienbach and Pfäffikon SZ – is among the most sought-after residential areas in Switzerland: low taxes, top infrastructure and only 25 minutes from Zurich. The property market is correspondingly exclusive. Our relocation services in the Höfe region give you access to the finest properties and guide you through every administrative step.",
        "Many of our clients in Höfe are entrepreneurial families and executives. Your personal assistant and lifestyle concierge are firmly anchored here – from household management to event planning on Lake Zurich.",
      ],
      highlights: [
        "Home search in Wollerau, Freienbach & Pfäffikon SZ",
        "Exclusive properties & off-market listings",
        "Municipal registration & authorities in the Höfe district",
        "Family services: schools, childcare & clubs",
        "25 minutes to Zurich – perfectly connected",
      ],
    },
  },
  {
    slug: "lugano",
    name: "Lugano",
    canton: { de: "Kanton Tessin", en: "Canton of Ticino" },
    de: {
      intro: [
        "Lugano verbindet Schweizer Zuverlässigkeit mit mediterranem Lebensgefühl – und ist damit eine der beliebtesten Städte für Zweitwohnsitze und internationale Zuzüger. Ob Ferienresidenz am Lago di Lugano oder beruflicher Neustart im Tessin: Wir sind Ihre persönliche Unterstützung vor Ort.",
        "Unsere Relocation Services, persönliche Assistenz und Home & Property Management stehen in Lugano und der ganzen Region zur Verfügung. Wir arbeiten auf Deutsch und Englisch und koordinieren vor Ort mit geprüften, italienischsprachigen Dienstleistern – Sie haben nur eine Ansprechperson: uns.",
      ],
      highlights: [
        "Wohnungssuche & Relocation in Lugano und am Lago",
        "Betreuung von Ferienresidenzen & Zweitwohnsitzen",
        "Persönliche Assistenz auf Deutsch & Englisch",
        "Koordination italienischsprachiger Handwerker & Dienstleister",
        "Lifestyle Concierge: See, Berge & Dolce Vita",
      ],
    },
    en: {
      intro: [
        "Lugano combines Swiss reliability with Mediterranean lifestyle – making it one of the most popular cities for second homes and international newcomers. Whether a holiday residence on Lake Lugano or a professional new start in Ticino: we are your personal support on the ground.",
        "Our relocation services, personal assistance and home & property management are available in Lugano and the entire region. We work in German and English and coordinate locally with vetted Italian-speaking service providers – you have only one point of contact: us.",
      ],
      highlights: [
        "Home search & relocation in Lugano and around the lake",
        "Care of holiday residences & second homes",
        "Personal assistance in German & English",
        "Coordination of Italian-speaking craftsmen & providers",
        "Lifestyle concierge: lake, mountains & dolce vita",
      ],
    },
  },
];

export default cities;
